import type { IconNames } from "@/v2-ui/icon/icon.types"

const USER_STATUS_PROVISIONED = 1
export const USER_STATUS_ACTIVE = 2
export const USER_STATUS_BLOCKED = 3
export const USER_STATUS_REMOVED = 4

/** Filter options for the status column, mirroring the board pills. */
export const USER_STATUS_FILTER_OPTIONS = [
  { label: "Provisioned", value: String(USER_STATUS_PROVISIONED) },
  { label: "Active", value: String(USER_STATUS_ACTIVE) },
  { label: "Blocked", value: String(USER_STATUS_BLOCKED) },
  { label: "Removed", value: String(USER_STATUS_REMOVED) },
]

type UserStatusStyle = {
  iconColor: string
  iconSrc: IconNames
}

const USER_STATUS_STYLES: Record<number, UserStatusStyle> = {
  [USER_STATUS_PROVISIONED]: {
    iconColor: "text-muted-foreground",
    iconSrc: "clock",
  },
  [USER_STATUS_ACTIVE]: {
    iconColor: "text-green-500",
    iconSrc: "check-circle",
  },
  [USER_STATUS_BLOCKED]: { iconColor: "text-amber-500", iconSrc: "lock" },
  [USER_STATUS_REMOVED]: { iconColor: "text-destructive", iconSrc: "trash" },
}

const DEFAULT_USER_STATUS_STYLE: UserStatusStyle = {
  iconColor: "text-muted-foreground",
  iconSrc: "question",
}

export function getUserStatusStyle(code: number) {
  return USER_STATUS_STYLES[code] ?? DEFAULT_USER_STATUS_STYLE
}
